// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CL8h1","content":"styles_content__BJF0A","dot":"styles_dot__RPn6y","load":"styles_load__lz5vW"};